import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Thessaly Voss',
  role: 'Chief Executive Officer',
  initials: 'TV',
  bio: 'Former offensive security operative. Architected defense grids for sovereign wealth funds.'
}, {
  name: 'Caspian Drell',
  role: 'Chief Technology Officer',
  initials: 'CD',
  bio: 'Pioneer in quantum-resistant cryptography. Holds 14 patents in zero-trust networking.'
}, {
  name: 'Isolde Kresh',
  role: 'Head of Threat Intelligence',
  initials: 'IK',
  bio: 'Ex-intelligence analyst specializing in state-sponsored APT tracking and attribution.'
}, {
  name: 'Fenwick Oram',
  role: 'Lead Security Architect',
  initials: 'FO',
  bio: 'Specializes in deep-packet inspection and automated incident response playbooks.'
}];
export function TeamSection() {
  return <section className="py-24 bg-brand-darker border-t border-brand-border" data-id="element-211">
      <div className="container mx-auto px-6" data-id="element-212">
        <div className="mb-16" data-id="element-213">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-mono font-bold text-white mb-4" data-id="element-214">
            <span className="text-brand-steel mr-2" data-id="element-215">/</span>
            The Operatives
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-400 text-lg max-w-2xl" data-id="element-216">
            Our leadership comprises veterans of cyber warfare, intelligence
            agencies, and elite red teams.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-217">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-218">
              <div className="mb-6 relative inline-block" data-id="element-219">
                <div className="w-24 h-24 rounded-full bg-brand-dark border-2 border-brand-border flex items-center justify-center group-hover:border-brand-steel transition-colors relative z-10" data-id="element-220">
                  <span className="font-mono text-2xl font-bold text-slate-300 group-hover:text-white transition-colors" data-id="element-221">
                    {member.initials}
                  </span>
                </div>
                {/* Decorative glow behind avatar */}
                <div className="absolute inset-0 bg-brand-steel/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-0" data-id="element-222" />
              </div>

              <h3 className="text-xl font-mono font-bold text-white mb-1" data-id="element-223">
                {member.name}
              </h3>
              <div className="text-sm font-mono text-brand-cyan mb-4" data-id="element-224">
                {member.role}
              </div>
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-225">
                {member.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}